export const APP_NAME = 'WellnessLoop'

export const COHORT_DISPLAY_NAMES = {
  'energizers-march-cohort': 'Energizers - March Cohort',
  'energizers-june-cohort': 'Energizers - June Cohort',
  'energizers-sept-2026-cohort': 'Energizers - Sept 2026 Cohort',
}

export const API_ENDPOINTS = {
  AUTH: {
    MAGIC_LINK: '/api/auth/magic-link', // Deprecated - use OTP
    OTP: '/api/auth/otp',
    VERIFY_OTP: '/api/auth/verify-otp',
    VERIFY: '/api/auth/verify', // For backward compatibility with magic links
    SEND_VERIFICATION: '/api/auth/send-verification',
  },
  PROGRAMS: {
    ENROLL: (slug) => `/api/programs/${slug}/enroll`,
    STATS: (slug) => `/api/programs/${slug}/stats`,
    SESSIONS: (slug) => `/api/programs/${slug}/sessions`,
    SESSION: (slug, sessionNumber) => `/api/programs/${slug}/sessions/${sessionNumber}`,
    ENROLLMENT: (slug) => `/api/programs/${slug}/enrollment`,
    CHECK_INS: (slug) => `/api/programs/${slug}/check-ins`,
    FEEDBACK: (slug) => `/api/programs/${slug}/feedback`,
    BOOKING_REQUESTS: (slug) => `/api/programs/${slug}/booking-requests`,
    SESSION_FORMS: {
      SUBMIT: (slug) => `/api/programs/${slug}/session-forms`,
      GET: (slug, sessionNumber) => `/api/programs/${slug}/session-forms/${sessionNumber}`,
      ALL: (slug, sessionNumber) => `/api/programs/${slug}/facilitator/session-forms/${sessionNumber}`,
    },
  },
  FACILITATORS: {
    LIST: '/api/facilitators',
    PROFILE: '/api/facilitators/profile',
    TAGS: '/api/facilitators/tags',
    ONBOARD: (token) => `/api/facilitators/auth/onboard/${token}`,
    OTP: '/api/facilitators/auth/otp',
    VERIFY_OTP: '/api/facilitators/auth/verify-otp',
    FEEDBACK: '/api/facilitators/feedback',
    BUILD3_INTEREST: '/api/facilitators/build3-interest',
    WELLNESS_COLLABORATIVE: '/api/facilitators/wellness-collaborative',
  },
  CLASSES: {
    ENROLL: (classId) => `/api/classes/${classId}/enroll`,
    MY_ENROLLMENTS: '/api/classes/enrollments/me',
    LEAVE: (id) => `/api/classes/enrollments/${id}/leave`,
    CHECK_IN: (id) => `/api/classes/enrollments/${id}/check-ins`,
    FEEDBACK: (id) => `/api/classes/enrollments/${id}/feedback`,
    ROSTER: (classId) => `/api/facilitators/classes/${classId}/roster`,
    DIRECT_ENROLL: (classId) => `/api/facilitators/classes/${classId}/enrollments`,
    APPROVE: (classId, id) => `/api/facilitators/classes/${classId}/enrollments/${id}/approve`,
    REJECT: (classId, id) => `/api/facilitators/classes/${classId}/enrollments/${id}/reject`,
    REMOVE: (classId, id) => `/api/facilitators/classes/${classId}/enrollments/${id}/remove`,
    ATTENDANCE: (classId, id) => `/api/facilitators/classes/${classId}/enrollments/${id}/attendance`,
  },
  COHORT_SIGNUPS: {
    CREATE: '/api/cohort-signups',
    STATS: '/api/cohort-signups/stats',
    ME: '/api/cohort-signups/me',
    ALL: '/api/cohort-signups',
    SESSION_CHECK_INS: '/api/cohort-signups/session-check-ins',
  },
  MID_DAY_RESET: {
    SIGNUP: '/api/mid-day-reset-signups',
    ALL: '/api/mid-day-reset-signups',
  },
  DASHBOARD: {
    STATS: '/api/dashboard/stats',
    RECENT_ACTIVITY: '/api/dashboard/recent-activity',
  },
  CORPORATE_CONSULTATIONS: {
    CREATE: '/api/corporate-consultations',
  },
}

export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  FACILITATORS: '/facilitators',
  FACILITATOR_ONBOARD: (token) => `/facilitators/onboard/${token}`,
  COHORT_SIGNUP: (slug) => `/${slug}-signup`,
  COHORT_DASHBOARD: (slug) => `/${slug}/dashboard`,
  COHORT_AUTH_VERIFY: (slug) => `/${slug}-auth/verify`,
  MID_DAY_RESET: '/mid-day-reset',
  MY_CLASSES: '/my-classes',
  MY_CLASS_HISTORY: (id) => `/my-classes/${id}/history`,
}
